import React from 'react';
import { Text } from '@consta/uikit/Text';
import cn from 'classnames/bind';
import styles from './styles.styl';
import { Button } from '@consta/uikit/Button';
import { SurveyStatusEnum, SurveyTypeEnum } from 'src/utils/enum';
import parse from 'html-react-parser';

const cx = cn.bind(styles);

export interface TakingSurveyGreetingProps {
  title: string;
  description: string;
  status: number;
  turnStep: (step: string) => void;
  maxScore: number;
  type: number;
}

const TakingSurveyGreeting: React.FC<TakingSurveyGreetingProps> = ({
  title,
  description,
  status,
  turnStep,
  maxScore,
  type,
}) => {
  const isTest = type === SurveyTypeEnum.TEST;

  const buttonLabel = isTest ? 'Начать тестирование' : 'Начать опрос';

  const button =
    status === SurveyStatusEnum.ENDED ? (
      <Button label={buttonLabel} view="primary" size="m" disabled />
    ) : (
      <Button
        label={buttonLabel}
        view="primary"
        size="m"
        onClick={() => turnStep('start')}
      />
    );

  const changeDescriptionLinks = (description: string) => {
    // const newDescription = description.split(" ", n);
    const newDescription = description.replace(
      /((http|https|ftp):\/\/[\w?=&./-;#~%-]+(?![\w\s?&./;#~%"=-]*>))/g,
      `<a href='$1' target='_blank' rel="noopener">$1</a>`,
    );
    return newDescription;
  };

  const changedDescription = changeDescriptionLinks(description);
  const changedTitle = changeDescriptionLinks(title);

  return (
    <div className={cx('TakingSurveyGreeting')}>
      <Text
        className={cx('TakingSurveyGreeting__title')}
        size="xl"
        view="primary"
      >
        {parse(changedTitle)}
      </Text>
      <Text
        className={cx('TakingSurveyGreeting__description')}
        size="s"
        view="primary"
      >
        {parse(changedDescription)}
      </Text>
      {button}
      {isTest && (
        <Text
          className={cx('TakingSurveyGreeting__maxScore')}
          size="s"
        >{`Максимальное количество баллов: ${maxScore}`}</Text>
      )}
    </div>
  );
};

export default TakingSurveyGreeting;
